import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Sparkles } from 'lucide-react';
import BrandLogo from './BrandLogo';

function Footer() {
  return (
    <footer className="app-footer">
      <div className="container footer-inner">
        <div className="footer-top">
          <div className="footer-brand-col">
            <BrandLogo />
            <p className="footer-tagline">
              CampNote is your campus academic hub — a centralized repository where university students and faculty organize, discover, and instantly download lecture notes, assignments, textbooks, and previous year question papers.
            </p>
            
          </div>

          <div className="footer-links-group">
            <div className="footer-col">
              <h4>Quick Navigation</h4>
              <ul>
                <li><Link to="/">Home Overview</Link></li>
                <li><a href="/#departments">All Departments</a></li>
                <li><a href="/#features">Key Features</a></li>
                <li><a href="/#recent">Recent Uploads</a></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Supported Formats</h4>
              <ul>
                <li><span className="footer-format-item">PDF Documents (.pdf)</span></li>
                <li><span className="footer-format-item">Word Documents (.docx, .doc)</span></li>
                <li><span className="footer-format-item">Images (.jpg, .jpeg, .png)</span></li>
                <li><span className="footer-format-item">Handwritten Notes</span></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Administration</h4>
              <ul>
                <li><Link to="/login">Admin Portal</Link></li>
                <li><Link to="/admin">Dashboard</Link></li>
                <li><Link to="/admin/upload">Upload Resource</Link></li>
                <li><Link to="/admin/files">Document Manage</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} CampNote. All rights reserved. Built for campus life.</p>
          <div className="footer-bottom-links">
            <span className="footer-accent-text">Organized • Fast • Accessible</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
